import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewWorkloadModule"
const debug = false

export class ViewWorkloadModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_WORKLOAD, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Workload"
        this.description                = "The Workload module provides a comprehensive overview of team member workloads, allowing for efficient resource allocation and workload balancing. This feature offers visual representations of individual and team workloads, enabling managers to identify potential bottlenecks and redistribute tasks as needed. "
        this.svgIcon                    = "isvg-view-workload"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-workload"
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.parentSection              = SettingsParentSection.VIEWS

        this.feature                    = Feature.WORKLOAD
        this.validateFeature()

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}